import React from 'react';
import { Snackbar, Alert } from '@mui/material';

/**
 * Standard paired success/error snackbars for page-level feedback.
 * Drop-in replacement for repeated Snackbar+Alert blocks across the app.
 */
export default function PageSnackbars({
  successMessage,
  errorMessage,
  onCloseSuccess,
  onCloseError,
  successAutoHideDuration = 6000,
  errorAutoHideDuration = 6000,
  anchorOrigin,
  successAlertSx,
  errorAlertSx,
  successMessageSuffix,
}) {
  const snackbarProps = anchorOrigin ? { anchorOrigin } : {};

  return (
    <>
      <Snackbar
        open={Boolean(successMessage)}
        autoHideDuration={successAutoHideDuration}
        onClose={onCloseSuccess}
        {...snackbarProps}
      >
        <Alert
          onClose={onCloseSuccess}
          severity="success"
          sx={{ width: '100%', ...(successAlertSx || {}) }}
        >
          {successMessage}
          {successMessageSuffix}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Boolean(errorMessage)}
        autoHideDuration={errorAutoHideDuration}
        onClose={onCloseError}
        {...snackbarProps}
      >
        <Alert
          onClose={onCloseError}
          severity="error"
          sx={{ width: '100%', ...(errorAlertSx || {}) }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
